var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"grey--text mb-5 text-h4"},[_vm._v("About us")])])}
var staticRenderFns = []

export { render, staticRenderFns }